import { useQContent } from '@exam-management/common/qcontent-provider';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import {
  EDITABLE_QUESTION_DETAILS_STATUSES,
  PREVIEWABLE_QUESTION_STATUSES,
} from '@exam-management/qcontent-management';
import { Button, VisibilityOutlinedIcon } from '@shared/components';
import { useDisclosure } from '@shared/hooks';
import { useHasPermission } from '@shared/permissions';

import { FormSubQuestionPreviewModal } from '../form-sub-question-preview-modal';
import { SubQuestionPreviewModal } from '../sub-question-preview-modal';

export default function SubQuestionPreviewButton() {
  const { qContent: subQuestion } = useQContent();

  const [isPreviewModalOpen, { close: closePreviewModal, open: openPreviewModal }] =
    useDisclosure(false);
  const [isFormPreviewModalOpen, { close: closeFormPreviewModal, open: openFormPreviewModal }] =
    useDisclosure(false);

  const hasUpdatePermission = useHasPermission(APP_PERMISSIONS.QBANK.QUESTION.UPDATE);
  const shouldDisablePreview = !PREVIEWABLE_QUESTION_STATUSES.includes(subQuestion.status);

  const isEditable =
    EDITABLE_QUESTION_DETAILS_STATUSES.includes(subQuestion.status) && hasUpdatePermission;

  const handleClick = () => {
    if (isEditable) return openFormPreviewModal();

    return openPreviewModal();
  };

  return (
    <>
      <Button
        color='secondary'
        variant='outlined'
        startIcon={<VisibilityOutlinedIcon />}
        disabled={shouldDisablePreview}
        onClick={handleClick}
      >
        Preview Question
      </Button>
      {!shouldDisablePreview ? (
        <>
          <SubQuestionPreviewModal open={isPreviewModalOpen} onClose={closePreviewModal} />
          <FormSubQuestionPreviewModal
            open={isFormPreviewModalOpen}
            onClose={closeFormPreviewModal}
          />
        </>
      ) : null}
    </>
  );
}
